import { setAxiosConfig } from 'redux-json-api';
import { API_PATH, API_ORIGIN } from '~/config';

const setApiConnectionConfig = (store: any) => {
  const apiUrl = new URL(API_PATH, API_ORIGIN);

  store.dispatch(
    setAxiosConfig({
      baseURL: apiUrl.href,
    })
  );
};

export { setApiConnectionConfig };
